/* src/app/views/area-publica/catalogo-projetos/project-card-public/project-card-public.component.scss */
.card .delete-btn {
  position: absolute;
  z-index: 2;
  right: 0;
}
.card .project-pic {
  height: 200px;
  object-fit: cover;
  line-break: anywhere;
}
.card .title {
  font-size: 18px;
  font-weight: 500;
  color: #2E3241;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  height: 42px;
}
.mat-mdc-card-image {
  margin: 0 -32px 0 -32px !important;
  padding-bottom: 0 !important;
}
.mat-mdc-card-image {
  width: calc(100% + 64px) !important;
  margin: 0 -32px 0 -32px !important;
}
.mat-mdc-card {
  padding: 0 32px 32px 32px;
}
.mat-mdc-card-content {
  margin-bottom: 32px !important;
}
.project-image-container {
  position: relative;
  display: inline-block;
  width: 100%;
  margin-bottom: 32px;
}
.project-image-container:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: rgba(46, 50, 65, 0.3);
  margin: 0 -32px 0 -32px;
  width: calc(100% + 64px);
}
/*# sourceMappingURL=project-card-public.component.css.map */
